export const achievementGroups = {JOURNEY: '旅程', CATEGORY: '类别', COLLECTION: '合集', DAILY: '每日', WEEKLY: '每周'};
export const durationRewardTypes = ['NO_ADS', 'WATERMARK', 'UNLIMITED_HINTS', 'UNLIMITED_JIGSORT'];
export const referenceLanguages = {ZH_HANS: '中文', EN: '英语', ES: '西班牙语', PT: '葡萄牙语', JA: '日语', DE: '德语', FR: '法语', SV: '瑞典语'};

/** 资料是 JSON；克隆时也脱离 Vue 响应式代理，保留未展示字段，避免页面投影覆盖原资料。 */
export function referenceDraft(definition = {}) {
  const draft = JSON.parse(JSON.stringify(definition));
  draft.name ||= '';
  draft.description ||= '';
  draft.display_group ||= '';
  draft.i18n_name ||= {};
  draft.i18n_desc ||= {};
  draft.levels ||= [];
  for (const level of draft.levels) {
    level.i18n_desc ||= {};
    level.i18n_progress ||= {};
    level.reward_items ||= [];
  }
  return draft;
}

/** 仅替换选中的资料，保留其他成就和未在表单中展示的历史字段。 */
export function catalogWithReference(catalog, draft, id, fallbackName, resources) {
  if (!/^[A-Za-z0-9][A-Za-z0-9_.:-]{0,127}$/.test(id) || ['constructor', 'prototype', '__proto__'].includes(id)) {
    throw new Error('请填写有效的成就标识');
  }
  const result = JSON.parse(JSON.stringify(catalog));
  const reference = JSON.parse(JSON.stringify(draft));
  reference.achievement_id = id;
  reference.name = reference.name?.trim() || fallbackName;
  if (!reference.name) throw new Error('请填写成就名称');
  reference.section_type = ['DAILY', 'WEEKLY'].includes(reference.display_group) ? reference.display_group : 'LONG_TERM';
  const old = (catalog.achievements || []).find(item => item.achievement_id === id);
  // 新阶段只分配未使用过的标识；删除资料不会复用已有奖励图片的绑定键。
  const levelIds = new Set((catalog.achievements || []).flatMap(item => (item.levels || []).map(level => level.level_id)));
  const imageKeys = new Set([
    ...Object.keys(resources.reward_slots || {}),
    ...(old?.levels || []).flatMap(level => (level.reward_items || []).map(reward => reward.resource_key).filter(Boolean)),
  ]);
  for (const [index, level] of reference.levels.entries()) {
    if (!level.level_id) {
      let number = index + 1;
      while (levelIds.has(`${id}_l${number}`) || [...imageKeys].some(key => key.startsWith(`${id}_l${number}:`))) number++;
      level.level_id = `${id}_l${number}`;
      levelIds.add(level.level_id);
    }
    level.order = index + 1;
    if (!Number.isFinite(level.target) || level.target < 0) throw new Error(`第 ${index + 1} 阶段的目标应为非负数字`);
    for (const [rewardIndex, reward] of level.reward_items.entries()) {
      const isDuration = durationRewardTypes.includes(reward.type);
      if (!reward.type || (!isDuration && (!Number.isFinite(reward.quantity) || reward.quantity <= 0))) throw new Error(`第 ${index + 1} 阶段的奖励类型和数量不完整`);
      if (reward.type === 'TOOL' && !reward.item_id) throw new Error(`第 ${index + 1} 阶段请选择道具`);
      if (isDuration && (!Number.isFinite(reward.duration_ms) || reward.duration_ms <= 0)) throw new Error(`第 ${index + 1} 阶段请填写奖励时长`);
      if (reward.type === 'IMAGE' && !reward.resource_key) {
        let number = rewardIndex;
        while (imageKeys.has(`${level.level_id}:${number}`)) number++;
        reward.resource_key = `${level.level_id}:${number}`;
        imageKeys.add(reward.resource_key);
      }
    }
  }
  result.achievements ||= [];
  const index = result.achievements.findIndex(item => item.achievement_id === id);
  if (index < 0) result.achievements.push(reference);
  else result.achievements[index] = reference;
  return result;
}
